import React from 'react';
import { styled } from '@linaria/react';

function RoundedButtonWrapper() {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 210 95"
    >
      <path
        fill="var(--color-background)"
        d="M106 -0.000976562C37.9453 -0.00176305 22.4303 55.7816 18.969 77.4947C18.1912 82.3738 14.3724 86.4021 9.46192 86.9477L0 87.999V94.499H200L210 87.999L202.407 87.0499C197.556 86.4435 193.814 82.4361 193.049 77.6075C189.623 55.9758 174.173 -0.000188692 106 -0.000976562Z"
      ></path>
    </Svg>
  );
}

const Svg = styled.svg`
  position: absolute;
  top: -14px;
  left: 0;
  right: 0;
  width: 105px;
  height: 47.5px;
  margin-inline: auto;
  transform: translateY(-30px);
  pointer-events: none;
`;

export default RoundedButtonWrapper;
